import type { DataTableProps } from 'react-md'
import { DataTable } from 'react-md'
import styled, { css } from 'styled-components'

type StyledDataTableProps = DataTableProps & {
	hideHeaderCheckbox?: boolean
}

const StyledDataTable = styled(DataTable)<{ $hideHeaderCheckbox?: boolean }>`
	${({ $hideHeaderCheckbox }) =>
		$hideHeaderCheckbox &&
		css`
			thead label.md-selection-control-label {
				display: none;
			}
		`}
`

function ViiluDataTable({
	hideHeaderCheckbox,
	...props
}: StyledDataTableProps) {
	return <StyledDataTable $hideHeaderCheckbox={hideHeaderCheckbox} {...props} />
}

export default ViiluDataTable
